// TCIO Design Tokens — single source of truth (ratified 2026-08-07 spec)
// Phase 1 of the redesign. All colors flow from here; no scattered hexes.

export const tokens = {
  // TCIO Navy (navigation)
  navy950: '#071A2D', navy900: '#0A2239', navy800: '#103554',
  // Brand blues
  blue700: '#336090', blue600: '#4479B0', blue500: '#4C8AC7', blue400: '#85AACF',
  // AI / interactive
  ai: '#0878E8', aiHover: '#0669CC', aiSoft: '#EAF4FF',
  // Supporting accents (facelift palette expansion, 2026-08-27)
  purple: '#7C5CE7', purpleSoft: '#F1EEFF',
  teal: '#18A6B8', tealSoft: '#E8F7F9',
  // Clinical surfaces
  canvas: '#F4F8FB', surface: '#FFFFFF', surfaceSoft: '#F8FAFC',
  border: '#D8E3EE', borderSoft: '#E8EEF4',
  // Typography
  ink: '#22303E', textSecondary: '#5D6B7A', textMuted: '#8291A1',
  // Semantic status
  success: '#169B62', successBg: '#EAF8F1',
  warning: '#F59E0B', warningBg: '#FFF7E6',
  danger: '#E5484D', dangerBg: '#FDEEEF',
  // LOC identity colors (Bed Board brief section 5, ratified 2026-09-01):
  // level-of-care identity ONLY - never reuse for auth/semantic/financial state.
  locDtx: '#E99A18', locDtxSoft: '#FFF6E5',
  locRtc: '#4479B0', locRtcSoft: '#EDF3FA',
  locPhp: '#18A6B8', locPhpSoft: '#E8F7F9',
  locIop: '#7C5CE7', locIopSoft: '#F1EEFF',
  // Gender signal (Bed Board): functional colors staff rely on, tokenized.
  genderM: '#3B82F6', genderF: '#EC4899',
  // Chrome
  radiusControl: 9, radiusCard: 11,
  shadow: '0 2px 8px rgba(20, 45, 70, 0.06)',
  font: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
};

// LEGACY COMPATIBILITY EXPORT — the 12 EMR files consume this exact key set.
// Same keys the old per-file `const T = {}` carried, mapped onto the new tokens.
// New code should import { tokens }; T exists so no consumer file changes internally.
export const T = {
  bg: tokens.surfaceSoft, surface: tokens.surface,
  b100: tokens.borderSoft, b200: tokens.border, b300: '#C3D2E0',
  rose: tokens.ai, roseDeep: tokens.blue700,
  ink: tokens.ink, inkSoft: tokens.textSecondary,
  blocking: tokens.danger, blockingBg: tokens.dangerBg,
  warning: tokens.warning, warningBg: tokens.warningBg,
  pass: tokens.success, passBg: tokens.successBg,
  info: tokens.blue600, infoBg: tokens.aiSoft,
};
